import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";

import Assignment from "@material-ui/icons/Assignment";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoGrid from "components/EnergyCompany/Grid/InfoGrid.jsx";
import InfoGridItem from "components/EnergyCompany/Grid/InfoGridItem.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { capitalizeString, CNPJMask, numberToBRL, zipCodeMask } from "services/utils";

const Informations = ({ empresa }) => (
  <GridContainer>
    <GridItem xs={12}>
      <ECCard
        content={
          <InfoGrid>
            {empresa.commercialName ? ([
              <InfoGridItem key="1" label="Razão Social" value={empresa.name} />,
              <InfoGridItem key="2" label="Nome Fantasia" value={empresa.commercialName} />,
            ]) : (
              <InfoGridItem label="Razão Social" modifiers={["forceNewFullRowModifier"]} value={empresa.name} />
            )}

            <InfoGridItem label="Atividade Principal" modifiers={["forceNewFullRowModifier"]} value={capitalizeString(get(empresa, "cnae.nome", ""))} />

            <InfoGridItem label="CNPJ" modifiers={["forceNewRowModifier"]} value={CNPJMask(empresa.cnpj)} />
            <InfoGridItem label="Tipo" value={capitalizeString(empresa.hierarchicalType)} />

            <InfoGridItem label="Logradouro" modifiers={["forceNewRowModifier"]} value={capitalizeString(get(empresa, "address.street", ""))} />
            <InfoGridItem label="Número" value={get(empresa, "address.number", "")} />

            <InfoGridItem label="CNAE" modifiers={["forceNewRowModifier"]} value={get(empresa, "cnae.id", "")} />
            <InfoGridItem label="Bairro" value={capitalizeString(get(empresa, "address.neighborhood", ""))} />

            <InfoGridItem label="Data de Abertura" modifiers={["forceNewRowModifier"]} value={moment(empresa.openDate).format("DD/MM/YYYY")} />
            <InfoGridItem label="CEP" value={zipCodeMask(get(empresa, "address.zipCode", ""))} />

            <InfoGridItem label="Telefone" modifiers={["forceNewRowModifier"]} value={empresa.phoneNumber} />
            <InfoGridItem label="Cidade" value={capitalizeString(get(empresa, "address.city", ""))} />

            <InfoGridItem label="Email" modifiers={["forceNewRowModifier"]} value={empresa.contactEmail} />
            <InfoGridItem label="Estado" value={capitalizeString(get(empresa, "address.state.name", ""))} />

            <InfoGridItem label="Capital Social" modifiers={["forceNewRowModifier"]} value={numberToBRL(empresa.shareCapital)} />
            {!!empresa.notaRisco && (
              <InfoGridItem label="Índice Alavancagem" value={get(empresa, "notaRisco", "")} />
            )}

            {!empresa.agents.length && (
              <InfoGridItem label="Observação" modifiers={["forceNewFullRowModifier"]} value="Este consumidor é cativo e não se encontra na base da CCEE." />
            )}
          </InfoGrid>
        }
        icon={<Assignment />}
        title="Informações"
      />
    </GridItem>
  </GridContainer>
);

Informations.propTypes = {
  empresa: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string,
      neighborhood: PropTypes.string,
      number: PropTypes.string,
      state: PropTypes.shape({
        name: PropTypes.string,
      }),
      street: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    cnae: PropTypes.shape({
      id: PropTypes.string,
      nome: PropTypes.string,
    }).isRequired,
    contactEmail: PropTypes.string,
    hierarchicalType: PropTypes.string,
    mainActivity: PropTypes.string,
    name: PropTypes.string.isRequired,
    openDate: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string,
    shareCapital: PropTypes.number,
  }).isRequired,
};

export default Informations;



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/Informations.jsx